

















































































































import { Component, Prop, Vue} from 'vue-property-decorator';
import { Placename } from '../models/Placename';
import PlacenamesService from '../services/PlacenamesService';

@Component
export default class Approvals extends Vue {

    get sources() {
        return this.$store.state.sources;
    }

    get approvalsShow(): boolean {
        return this.$store.state.leftDrawerContent.approvals;
    }

    get mapView(): __esri.MapView {
        return this.$store.state.mapView;
    }

    get unapprovedData() {
        return this.$store.state.unapproved.data;
    }

    get unapprovedLayer() {
        return this.$store.state.unapproved.layer;
    }

    get unapprovedLayerView() {
        return this.$store.state.unapproved.layerView;
    }

    get audioRootUrl() {
        return this.$store.getters.audioRootUrl;
    }

    public highlight: any;
    public isLoading: boolean = false;

    public onClose() {
        this.$store.dispatch('drawerToggleLeft', 'nothing');
    }

    public mounted() {
        console.log('Approvals: mounted()');
        console.log(this.unapprovedData);
    }

    public highlightMap(item: any) {
        console.log('Approvals: highlightMap()');
        if (this.highlight) {
            this.highlight.remove();
        }
        this.highlight = this.unapprovedLayerView.highlight(item.objectId);
        this.unapprovedLayer.queryFeatures({
            where: `OBJECTID = ${item.objectId}`,
            returnGeometry: true,
        }).then((results: __esri.FeatureSet) => {
            this.mapView.goTo(results.features);
        });
    }

    public highlightClear() {
        console.log('Approvals: highlightClear()');
        if (this.highlight) {
            this.highlight.remove();
        }
    }

    public zoomToPlacename(id: number) {
        console.log('Approvals: zoomToPlacename()');
        this.mapView.zoom = 15;
        this.unapprovedLayer.queryFeatures({
            where: `OBJECTID = ${id}`,
            returnGeometry: true,
        }).then((results: __esri.FeatureSet) => {
            this.mapView.goTo(results.features);
        });
    }

    public toggleApproval(item: any) {
        console.log('Approvals: toggleApproval()');
        this.isLoading = true;
        if (item.approved === 0) {
            PlacenamesService.approve(item.objectId)
            .then((response: any) => {
                console.log(response.data);
                this.$store.dispatch('refreshLayers');
                item.approved = 1;
                this.isLoading = false;
            })
            .catch((error: any) => {
                console.error(error);
                if (error.response) {
                    this.$store.dispatch('notify', error.response);
                }
            });

        } else {
            PlacenamesService.reject(item.objectId)
            .then((response: any) => {
                console.log(response.data);
                this.$store.dispatch('refreshLayers');
                item.approved = 0;
                this.isLoading = false;
            })
            .catch((error: any) => {
                console.error(error);
                if (error.response) {
                    this.$store.dispatch('notify', error.response);
                }
            });
        }
    }

    public removeFromList(id: number) {
        console.log('Approvals: removeFromList()');
        this.$store.state.unapproved.data = this.unapprovedData.filter((item: any) => item.objectId !== id);
        this.$store.dispatch('updateUnapprovedCount');
    }

    public editPlacename(id: number) {
        console.log('Approvals: editPlacename()');
        this.$store.dispatch('editPlacename', id);
    }

    public deleteConfirm(item: Placename) {
        console.log('Approvals: deleteConfirm()');
        this.$q.dialog({
            title: 'Confirm',
            message: 'Are you sure you want to delete?',
            cancel: true,
            persistent: true,
        }).onOk(() => {
            if (item) {
                this.$store.dispatch('deletePlacename', item.objectId);
                if (item.audioLink && item.audioLink.length) {
                    this.$store.dispatch('deleteAudioFile', item.audioLink);
                }
            }
        }).onCancel(() => {
            // console.log('>>>> Cancel')
        }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
        });
    }

    public playSound(id: number) {
        console.log('Approvals: playSound()');
        const audioElement = document.getElementById('audioElement' + id) as HTMLMediaElement;
        if (audioElement) {
            audioElement.play();
        }
    }

}

